import React, {useEffect, useRef, useState} from "react";
import { useNavigate, useLocation  } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { NannyIcon } from "../../assets/image/NannyIcon";
import { ParaprofessionalIcon } from "../../assets/image/ParaprofessionalIcon";
import { TeacherIcon } from "../../assets/image/TeacherIcon";
import { TutorIcon } from "../../assets/image/TutorIcon";
import { ArrowUpIcon } from "../../assets/image/ArrowUpIcon";

import { useSearchDetailsStore } from "../../store/useSearchDetailsStore";
import { useCategoryStore } from "../../store/useCategoryStore";
import {searchStore} from "../../store/searchStore";
import OldSlider from "../../components/common/Slider/OldSlider";

export const FilterModal = ({
                                 setType,
                             }) => {
    const { t, i18n } = useTranslation();
    const language = i18n.language;
    const [searchType, setSearchType] = useState("");
    const [isWorkExperience, setIsWorkExperience] = useState(false);
    const [openAdvancedSearch, setOpenAdvancedSearch] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const { profile } =
        useSearchDetailsStore();
    const { search, setSearch, localSearch, setLocalSearch, resetSearch, resetLocalSearch, previousLocation, setPreviousLocation } =
        searchStore();

    const {
        isCheck,
        setIsCheck,
    } = useCategoryStore();



    useEffect(() => {
        let type = "";
        let currentLocation = window.location.pathname;
        if (currentLocation === "/search-parents")
        {
            type = "parents";
        }
        else if (currentLocation === "/search-providers")
        {
            type = "providers";
        }
        else if (localStorage.getItem("user_type") === "parents")
        {
            type = "providers";
        }
        else
        {
            type = "parents";
        }

        if (currentLocation === "/search-providers" || currentLocation === "/search-parents")
        {
            if (localStorage.getItem("login") === "true")
            {
                setOpenAdvancedSearch(false);
                localStorage.setItem("login", "");
            }
            else
            {
                setOpenAdvancedSearch(true);
            }
            setPreviousLocation(currentLocation);
        }
        else if (currentLocation.includes("/profile-provider/") || currentLocation.includes("/profile-parents/"))
        {
            if (previousLocation === "/search-providers" || previousLocation === "/search-parents")
            {
                setOpenAdvancedSearch(true);
            }
            else
            {
                setOpenAdvancedSearch(false);
                resetLocalSearch();
                resetSearch();
                setPreviousLocation("");
            }
            if (previousLocation === "/search-providers")
            {
                type = "providers";
            }
            else if (previousLocation === "/search-parents")
            {
                type = "parents";
            }
        }
        else
        {
            setOpenAdvancedSearch(false);
            resetLocalSearch();
            resetSearch();
            setPreviousLocation("");
        }

        setSearchType(type);


    }, [location]);

    const handleElementById = (e) => {
        if (isCheck) {
            document.getElementById(e).style.display = "block";
            setIsCheck(false);
        } else {
            document.getElementById(e).style.display = "none";
            setIsCheck(true);
        }
    };


    const handleElementDisplay = (e, x) => {
        if (isCheck) {
            document.getElementById(e).style.display = "block";
            document.getElementById(x).style.display = "block";
            setIsCheck(false);
        } else {
            setIsCheck(true);
            document.getElementById(e).style.display = "none";
            document.getElementById(x).style.display = "none";
        }
    };

    const setRates = (rate) => {
        setLocalSearch({
            ...localSearch,
            "rates" : rate
        })
    }


    const handleMultiSelectValue = (field, data) => {
        let newData = localSearch[field];
        if (newData.includes(data))
            newData = newData.filter(x => x !== data);
        else
            newData = newData.concat(data);
        setLocalSearch({
            ...localSearch,
            [field]: newData
        })
    }
    const handleStringValue = (field, data) => {
        setLocalSearch({
            ...localSearch,
            [field]: data
        })
    }

    const handleWorkExperience = (event, data) => {
        handleStringValue("workExperience", data);
        setIsWorkExperience(!isWorkExperience);
    }

    const getStringValue = (field) => {
        if (field === "workExperience")
        {
            if (localSearch[field] === "0")
                return  t("search-years-0-1");
            else if (localSearch[field] === "1")
                return  t("search-years-2-4");
            else if (localSearch[field] === "2")
                return  t("search-years-5-9");
            else if (localSearch[field] === "3")
                return  t("search-years-9-more");
            else return t("choose-list");
        }
    }

    const getStringValueFromArray = (field) => {
        const items = [];
        localSearch[field].forEach((item) => {
            if (field === "jobCategory")
            {
                if (item === "data1")
                    items.push(t("Nanny"));
                if (item === "data2")
                    items.push(t("spec-education-teacher"));
                if (item === "data3")
                    items.push(t("spec-education-paraprofessional"));
                if (item === "data4")
                    items.push(t("Tutor"));
            }
            else if (field === "candidateYears")
            {
                if (item === "0")
                    items.push(t("years-18-23"));
                if (item === "1")
                    items.push(t("years-24-30"));
                if (item === "2")
                    items.push(t("years-31-40"));
                if (item === "3")
                    items.push(t("years-40"));
            }
            else items.push(t(item));
        });

        //const mapped = localSearch[field].map((val) => t(val));
        return items.join(', ');
    }


    const resetFilters = ()  =>{
        resetSearch();
        resetLocalSearch();

    }

    const handleSubmit = ()  =>{
        setType("");
        window.scrollTo({ top: 0, behavior: "smooth" });
        setSearch(localSearch);
        navigate("/search-"+searchType);
    }



    return (
        <div className="filter_header" id="">
            <div className="container">
                <div
                    className="filter_box"
                    onKeyPress={(e) => {
                        if (
                            e.key == "Enter" &&
                            localStorage.getItem("token") &&
                            localStorage.getItem("id")
                        ) {
                            localStorage.removeItem("searchdataprovider");
                            handleSubmit();
                        }
                    }}
                >
                    <div className="filter_search">
                        <div className="advance_search_filter">
                            <div
                                className={
                                    "advance_search_filter_input Profile_complete " +
                                    (!openAdvancedSearch ? (localStorage.getItem("token") !== null ? "" : "op") : "op")
                                }
                            >
                <span
                    id={"my-adv-filter"+(localStorage.getItem("token") !== null ? "" : "-public")}
                    onClick={(e) => {
                        if (localStorage.getItem("token") !== null) {
                            handleElementById("filterdata");
                            localStorage.setItem('advanced', isCheck)
                        }
                    }}
                >
                  {t("Advanced Search")}
                </span>
                                    <div
                                        className="filters_search detail work-experience"
                                        id="filterdata"
                                        style={
                                            !localStorage.getItem("token") ||
                                            openAdvancedSearch
                                                ? { display: "block" }
                                                : { display: "none" }
                                        }
                                    >
                                        <div className="form_group full border qualification">
                                            <label>{t("text-frequency")}</label>
                                            <div className="checkbox create checkbox-filter">
                                                <ul>
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            checked={localSearch.frequency.includes("Full time")}
                                                            onClick={(e) => handleMultiSelectValue("frequency", "Full time")}
                                                        />
                                                        <span> {t("full-time")}</span>
                                                    </li>
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            checked={localSearch.frequency.includes("Part time")}
                                                            onClick={(e) => handleMultiSelectValue("frequency", "Part time")}
                                                        />
                                                        <span> {t("part-time")}</span>
                                                    </li>
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            checked={localSearch.frequency.includes("Occasionally")}
                                                            onClick={(e) => handleMultiSelectValue("frequency", "Occasionally")}

                                                        />
                                                        <span> {t("occasionally")}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="form_group full border">
                                            <label>
                                                {t("Rate per hour")}
                                                {language === 'sr'
                                                    ? " (RSD)"
                                                    : " (USD)"}
                                            </label>
                                            <OldSlider rate={localSearch.rates} setRate={setRates} serbian={language === 'sr'}/>
                                            <span className="price">
                        {language === 'sr'
                            ? localSearch.rates.min * 100 + " - " + localSearch.rates.max * 100 + (localSearch.rates.max === 60 ? "+" : "")
                            : localSearch.rates.min + " - " + localSearch.rates.max + (localSearch.rates.max === 60 ? "+" : "")}
                      </span>
                                        </div>
                                        {searchType === "providers" ? (
                                            <div className="form_group full border">
                                                <div className="sortby">
                                                    <label>{t("Expected work experience")}</label>
                                                    <div className="sortby_select">
                                                        {isWorkExperience ? (
                                                            <div
                                                                className="close_eve"
                                                                onClick={(e) => setIsWorkExperience(!isWorkExperience)}
                                                            ></div>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <div className="drodownsearch select-filter search-select-parent">
                  <span className={"search-select-span" + (isWorkExperience ? " search-select-span-open" : "")} onClick={(e) => setIsWorkExperience(!isWorkExperience)}>
                    {getStringValue("workExperience")}
                  </span>
                                                            {isWorkExperience ? (
                                                                <ul style={{ minWidth: '100%' }}>
                                                                    <li
                                                                        onClick={(e) => handleWorkExperience(e, "")
                                                                        }
                                                                    >
                                                                        {t("choose-list")}
                                                                    </li>
                                                                    <li
                                                                        onClick={(e) => handleWorkExperience(e, "0")}
                                                                    >
                                                                        {t("search-years-0-1")}
                                                                    </li>
                                                                    <li
                                                                        onClick={(e) => handleWorkExperience(e, "1")}
                                                                    >
                                                                        {t("search-years-2-4")}
                                                                    </li>
                                                                    <li
                                                                        onClick={(e) => handleWorkExperience(e, "2")}
                                                                    >
                                                                        {t("search-years-5-9")}
                                                                    </li>
                                                                    <li
                                                                        onClick={(e) => handleWorkExperience(e, "3")}
                                                                    >

                                                                        {t("search-years-9-more")}
                                                                    </li>
                                                                </ul>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        ) : ("")}
                                        <div className="form_group full border">
                                            <label>{t("Number of children")}</label>
                                            <div className="children_number">
                                                <ul>
                                                    <li
                                                        onClick={(e) => handleMultiSelectValue("childNumber", "1")}
                                                        className={localSearch.childNumber.includes("1") ? "active" : ""}

                                                    >
                                                        1
                                                    </li>
                                                    <li
                                                        onClick={(e) => handleMultiSelectValue("childNumber", "2")}
                                                        className={localSearch.childNumber.includes("2") ? "active" : ""}
                                                    >
                                                        2
                                                    </li>
                                                    <li
                                                        onClick={(e) => handleMultiSelectValue("childNumber", "twins")}
                                                        className={localSearch.childNumber.includes("twins") ? "active" : ""}
                                                    >
                                                        {t("text-twins")}
                                                    </li>
                                                    <li
                                                        onClick={(e) => handleMultiSelectValue("childNumber", "3")}
                                                        className={localSearch.childNumber.includes("3") ? "active" : ""}
                                                    >
                                                        3+
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        {searchType === "parents" ? (
                                            <div className="job_performance">
                                            <div className="form_group   full border">
                                                <label>{t("child-age")}</label>
                                                <div className="text customselect ">

                                                        <span
                                                            className="keyword"
                                                            onClick={(e) =>
                                                                handleElementDisplay("cate5", "over2")
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                            }}
                                                        >
                              {getStringValueFromArray("childYears")}
                                                            {localSearch.childYears.length > 0 ? "" : t("choose-list")}
                            </span>

                                                </div>
                                                <div className="customselect inp">
                                                    <div
                                                        className="overflow"
                                                        id="over2"
                                                        onClick={(e) =>
                                                            handleElementDisplay("cate5", "over2")
                                                        }
                                                    ></div>
                                                    <div className="option" id="cate5">
                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                checked={localSearch.childYears.includes("years-0-1")}
                                                                onClick={(e) => handleMultiSelectValue("childYears", "years-0-1")}

                                                            />
                                                            <h3>{t("years-0-1")} </h3>
                                                            <span className="filter-multiselect-checkbox"></span>
                                                        </p>
                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                checked={localSearch.childYears.includes("years-1-3")}
                                                                onClick={(e) => handleMultiSelectValue("childYears", "years-1-3")}
                                                            />
                                                            <h3>{t("years-1-3")} </h3>
                                                            <span className="filter-multiselect-checkbox"></span>
                                                        </p>
                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                checked={localSearch.childYears.includes("years-4-7")}
                                                                onClick={(e) => handleMultiSelectValue("childYears", "years-4-7")}
                                                            />
                                                            <h3>{t("years-4-7")} </h3>
                                                            <span className="filter-multiselect-checkbox"></span>
                                                        </p>
                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                checked={localSearch.childYears.includes("years-8-10")}
                                                                onClick={(e) => handleMultiSelectValue("childYears", "years-8-10")}
                                                            />
                                                            <h3>{t("years-8-10")} </h3>
                                                            <span className="filter-multiselect-checkbox"></span>
                                                        </p>
                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                checked={localSearch.childYears.includes("years-11-15")}
                                                                onClick={(e) => handleMultiSelectValue("childYears", "years-11-15")}
                                                            />
                                                            <h3>{t("years-11-15")} </h3>
                                                            <span className="filter-multiselect-checkbox"></span>
                                                        </p>
                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                checked={localSearch.childYears.includes("years-16")}
                                                                onClick={(e) => handleMultiSelectValue("childYears", "years-16")}
                                                            />
                                                            <h3>{t("years-16")} </h3>
                                                            <span className="filter-multiselect-checkbox"></span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        ) : ("")}
                                        {searchType === "providers" ? (
                                            <div className="job_performance">
                                                <div className="form_group   full border">
                                                    <label>{t("Provider's preferred age")}</label>
                                                    <div className="text customselect ">

                                                        <span
                                                            className="keyword"
                                                            onClick={(e) =>
                                                                handleElementDisplay("cate5", "over2")
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                            }}
                                                        >
                              {getStringValueFromArray("candidateYears")}
                                                            {localSearch.candidateYears.length > 0 ? "" : t("choose-list")}
                            </span>

                                                    </div>
                                                    <div className="customselect inp">
                                                        <div
                                                            className="overflow"
                                                            id="over2"
                                                            onClick={(e) =>
                                                                handleElementDisplay("cate5", "over2")
                                                            }
                                                        ></div>
                                                        <div className="option" id="cate5">
                                                            <p>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={localSearch.candidateYears.includes("0")}
                                                                    onClick={(e) => handleMultiSelectValue("candidateYears", "0")}

                                                                />
                                                                <h3>{t("years-18-23")} </h3>
                                                                <span className="filter-multiselect-checkbox"></span>
                                                            </p>
                                                            <p>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={localSearch.candidateYears.includes("1")}
                                                                    onClick={(e) => handleMultiSelectValue("candidateYears", "1")}
                                                                />
                                                                <h3>{t("years-24-30")} </h3>
                                                                <span className="filter-multiselect-checkbox"></span>
                                                            </p>
                                                            <p>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={localSearch.candidateYears.includes("2")}
                                                                    onClick={(e) => handleMultiSelectValue("candidateYears", "2")}
                                                                />
                                                                <h3>{t("years-31-40")} </h3>
                                                                <span className="filter-multiselect-checkbox"></span>
                                                            </p>
                                                            <p>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={localSearch.candidateYears.includes("3")}
                                                                    onClick={(e) => handleMultiSelectValue("candidateYears", "3")}
                                                                />
                                                                <h3>{t("years-40")} </h3>
                                                                <span className="filter-multiselect-checkbox"></span>
                                                            </p>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : ("")}
                                        <div className="form_group full border qualification">
                                            <label>{t("start-date")}</label>
                                            <div className="checkbox create checkbox-filter">
                                                <ul>
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            name="b"
                                                            checked={
                                                                localSearch.withinWeek
                                                            }
                                                            onClick={(e) => {
                                                                handleStringValue("withinWeek",e.target.checked ? e.target.checked : "")
                                                            }}
                                                        />
                                                        <span> {t("Within a week")}</span>
                                                    </li>
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            name="b"
                                                            checked={
                                                                localSearch.withinMonth
                                                            }
                                                            onClick={(e) => {
                                                                handleStringValue("withinMonth",e.target.checked ? e.target.checked : "")
                                                            }}
                                                        />
                                                        <span> {t("Within a month")}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="form_group full qualification">
                                            <label>{t("Other options")}</label>
                                            <div className="checkbox create checkbox-filter">
                                                <ul>
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            name="b"
                                                            checked={
                                                                localSearch.carOrLicence
                                                            }
                                                            onClick={(e) => {
                                                                handleStringValue("carOrLicence",e.target.checked ? e.target.checked : "")
                                                            }}
                                                        />
                                                        <span> {searchType === "providers" ? t("Has car or valid driver licence") : t("Without transportation")}</span>
                                                    </li>
                                                    {searchType === "parents" ? (
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            name="b"
                                                            checked={
                                                                localSearch.thisWeek
                                                            }
                                                            onClick={(e) => {
                                                                handleStringValue("thisWeek",e.target.checked ? e.target.checked : "")
                                                            }}
                                                        />
                                                        <span> {t("Jobs posted within a week")}</span>
                                                    </li>
                                                    ) : ("")}
                                                    {searchType === "providers" ? (
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            name=""
                                                            checked={
                                                                localSearch.backgroundStatus
                                                            }
                                                            onClick={(e) => {
                                                                handleStringValue("backgroundStatus",e.target.checked ? "Confirmed" : "")
                                                            }}
                                                        />
                                                        <span> {t("Has a background check")}</span>
                                                    </li>
                                                    ) : ("")}
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            name="b"
                                                            checked={
                                                                localSearch.workingAbroad
                                                            }
                                                            onClick={(e) => {
                                                                handleStringValue("workingAbroad",e.target.checked ? "Yes" : "")
                                                            }}
                                                        />
                                                        <span> {searchType === "providers" ? t("Willing to work abroad") : t("Work abroad")}</span>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                        {searchType === "providers" ? (
                                            <div className="form_group full qualification">
                                                <label>{t("Experience with")}</label>
                                                <div className="checkbox create checkbox-filter">
                                                    <ul>
                                                        <li>
                                                            <input
                                                                type="checkbox"
                                                                name=""
                                                                checked={
                                                                    localSearch.newbornExperience
                                                                }
                                                                onClick={(e) => {
                                                                    handleStringValue("newbornExperience",e.target.checked ? "Yes" : "")
                                                                }}
                                                            />
                                                            <span> {t("Newborns")}</span>
                                                        </li>
                                                        <li>
                                                            <input
                                                                type="checkbox"
                                                                name=""
                                                                checked={
                                                                    localSearch.childSocialNeed
                                                                }
                                                                onClick={(e) => {
                                                                    handleStringValue("childSocialNeed",e.target.checked ? "Yes" : "")
                                                                }}
                                                            />
                                                            <span> {t("Kids with special needs")}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                {/* <div className='errorfield'>{error.message}</div> */}
                                            </div>
                                        ) : ("")}

                                        {searchType === "providers" ? (
                                            <div className="form_group full qualification">
                                                <label>{t("I need a tutor for")}</label>
                                                <div className="checkbox create checkbox-filter">
                                                    <ul>
                                                        <li>
                                                            <input
                                                                type="checkbox"
                                                                name=""
                                                                checked={localSearch.tutorClasses.includes("English")}
                                                                onClick={(e) => handleMultiSelectValue("tutorClasses", "English")}
                                                            />
                                                            <span> {t("english")}</span>
                                                        </li>
                                                        <li>
                                                            <input
                                                                type="checkbox"
                                                                name=""
                                                                checked={localSearch.tutorClasses.includes("Serbian")}
                                                                onClick={(e) => handleMultiSelectValue("tutorClasses", "Serbian")}
                                                            />
                                                            <span> {t("serbian")}</span>
                                                        </li>
                                                        <li>
                                                            <input
                                                                type="checkbox"
                                                                name=""
                                                                checked={localSearch.tutorClasses.includes("Mathematics")}
                                                                onClick={(e) => handleMultiSelectValue("tutorClasses", "Mathematics")}
                                                            />
                                                            <span> {t("mathematics")}</span>
                                                        </li>
                                                        <li>
                                                            <input
                                                                type="checkbox"
                                                                name=""
                                                                checked={localSearch.tutorClasses.includes("Physics")}
                                                                onClick={(e) => handleMultiSelectValue("tutorClasses", "Physics")}
                                                            />
                                                            <span> {t("physics")}</span>
                                                        </li>
                                                        <li>
                                                            <input
                                                                type="checkbox"
                                                                name=""
                                                                checked={localSearch.tutorClasses.includes("Chemistry")}
                                                                onClick={(e) => handleMultiSelectValue("tutorClasses", "Chemistry")}

                                                            />
                                                            <span> {t("chemistry")}</span>
                                                        </li>
                                                        <li>
                                                            <input
                                                                type="checkbox"
                                                                name=""
                                                                checked={localSearch.tutorClasses.includes("Online")}
                                                                onClick={(e) => handleMultiSelectValue("tutorClasses", "Online")}
                                                            />
                                                            <span> {t("Online classes")}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <button
                                            onClick={(e) => {
                                                handleSubmit();
                                            }}
                                        >
                                            {t("Refine result")}
                                        </button>
                                    </div>

                            </div>
                        </div>
                        <div className="filter_category Profile_complete ">
                            <div className="filter_category_select detail work-experience">
                                <div className="job_performance">
                                    <div className="form_group   full">
                                        <div className="customselect inp">
                                            <input
                                                id="my-fil-cat"
                                                className="keyword"
                                                type="text"
                                                placeholder={t("select")}
                                                value={getStringValueFromArray("jobCategory")}
                                            />
                                            <div
                                                className="overflow"
                                                id="over3"
                                                onClick={(e) => handleElementDisplay("cate6", "over3")}
                                            ></div>
                                            <div className="option" id="cate6">
                                                <p>
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            localSearch.jobCategory.includes("data1")
                                                        }
                                                        onClick={(e) => {
                                                            handleMultiSelectValue("jobCategory","data1")
                                                        }}

                                                    />
                                                    <h3>
                                                        <NannyIcon />

                                                        {t("text-nanny")}
                                                    </h3>
                                                    <span className="filter-multiselect-checkbox"></span>
                                                </p>
                                                <p>
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            localSearch.jobCategory.includes("data2")
                                                        }
                                                        onClick={(e) => {
                                                            handleMultiSelectValue("jobCategory","data2")
                                                        }}
                                                    />
                                                    <h3>
                                                        <TeacherIcon />
                                                        {t("spec-education-teacher")}
                                                    </h3>
                                                    <span className="filter-multiselect-checkbox"></span>
                                                </p>
                                                <p>
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            localSearch.jobCategory.includes("data3")
                                                        }
                                                        onClick={(e) => {
                                                            handleMultiSelectValue("jobCategory","data3")
                                                        }}
                                                    />
                                                    <h3>
                                                        <ParaprofessionalIcon />
                                                        {t("spec-education-paraprofessional")}
                                                    </h3>
                                                    <span className="filter-multiselect-checkbox"></span>
                                                </p>
                                                <p>
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            localSearch.jobCategory.includes("data4")
                                                        }
                                                        onClick={(e) => {
                                                            handleMultiSelectValue("jobCategory","data4")
                                                        }}
                                                    />
                                                    <h3>
                                                        <TutorIcon />
                                                        {t("text-tutor")}
                                                    </h3>
                                                    <span className="filter-multiselect-checkbox"></span>
                                                </p>
                                            </div>
                                            <span
                                                onClick={(e) => handleElementDisplay("cate6", "over3")}
                                            >
                        <ArrowUpIcon color={"#7D2B8B"} />
                      </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="city">
                            <input
                                type="text"
                                placeholder={t("city")}
                                id="my-fil-city"
                                onChange={(e) => handleStringValue("city", e.target.value)}
                                value={localSearch.city}
                            />
                        </div>
                        <div className="zip code">
                            <input
                                type="text"
                                placeholder={t("zip")}
                                id="my-fil-zip"
                                onChange={(e) => handleStringValue("zip", e.target.value)}
                                value={localSearch.zip}
                            />
                        </div>
                        <div className="distance">
                            <div className="distance_input">
                                <select
                                    name=""
                                    id="my-fil-dis"
                                    value={localSearch.distance}
                                    onChange={(e) =>
                                        handleStringValue("distance", e.target.value)
                                    }
                                >
                                    <option value="">
                                        {t("Distances")}
                                    </option>
                                    <option value={5}> 5 {t("Miles")}</option>
                                    <option value={10}>10 {t("Miles")}</option>
                                    <option value={15}>15 {t("Miles")}</option>
                                    <option value={20}>20 {t("Miles")}</option>
                                    <option value={25}>25 {t("Miles")}</option>
                                    <option value={30}>30 {t("Miles")}</option>
                                    <option value={35}>35 {t("Miles")}</option>
                                    <option value={40}>40 {t("Miles")}</option>
                                    <option value={45}>45 {t("Miles")}</option>
                                    <option value={50}>50 {t("Miles")}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="reset-div">
                        <button className="reset-filter" onClick={(e) => resetFilters()}>
                            X
                        </button>
                        <span className="tooltiptext">Reset filter</span>
                    </div>

                    <div className="search_box">

                        <div className="search_input">

                            <button
                                id="my-fil-search"
                                type="submit"
                                onClick={(e) => {
                                    handleSubmit();
                                }}
                            >
                                {t("text-search")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};